import { render, staticRenderFns } from "./ProductFormModal.vue?vue&type=template&id=3a3bd336&scoped=true&"
import script from "./ProductFormModal.vue?vue&type=script&lang=js&"
export * from "./ProductFormModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductFormModal.vue?vue&type=style&index=0&id=3a3bd336&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3bd336",
  null
  
)

export default component.exports